import { render } from "./WechatCallback.vue?vue&type=template&id=c86a4fda&scoped=true"
import script from "./WechatCallback.vue?vue&type=script&lang=js"
export * from "./WechatCallback.vue?vue&type=script&lang=js"

import "./WechatCallback.vue?vue&type=style&index=0&id=c86a4fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86a4fda"]])

export default __exports__